import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgSpinner = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 12,
				r: 7,
				stroke: "#DEEEFD",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#4384F5",
				strokeWidth: 2,
				d: "M5 12a7 7 0 0 0 7 7"
			})
		]
	})
});
export default SvgSpinner;
